import PropTypes from 'prop-types';
import {Circle, Mask, Img, Label} from './styles';
import placeholder from 'assets/img/placeholder.png';
import {useDragDetection} from 'lib/slider';

const RecipeCircle = ({data, onClick, selected}) => {
  const {handleMouseDown, dragging} = useDragDetection();

  function handleChildClick() {
    if (!dragging) {
      onClick();
    }
  }

  if (!data) return null;
  return (
    <Circle onMouseDownCapture={handleMouseDown} onClickCapture={handleChildClick}>
      <Mask selected={selected}>
        <Img
          src={data.image || placeholder}
          placeholderStyle={{borderRadius: '50%', overflow: 'hidden'}}
        />
      </Mask>
      <Label selected={selected}>{data.name}</Label>
      {/* <div>{`/wp/v2/recette_club?per_page=4&categories=${data.id}`}</div> */}
    </Circle>
  );
};

RecipeCircle.propTypes = {
  data: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default RecipeCircle;
